// src/pages/locations/tabs/CountriesTab.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

import ConfirmDialog from "@/components/shared/ui/ConfirmDialog";
import CountriesTable from "@/components/locations/countries/CountriesTable";

import { useCountriesList } from "../hooks/useCountriesList";
import { useLocationScope } from "../useLocationScope";
import { locationEditPath } from "../locations.access";
import { RefreshingStrip } from "../components/LocationFilters";

const CountriesTab: React.FC = () => {
  const navigate = useNavigate();
  const { search } = useLocationScope();

  const {
    filters,
    setFilters,
    page,
    setPage,
    pageSize,
    rows,
    total,
    isLoading,
    isFetching,
    deleting,
    confirmDelete,
    askDelete,
    cancelDelete,
    confirmDeleteRow,
  } = useCountriesList({ search });

  return (
    <>
      <RefreshingStrip show={isFetching && !isLoading} />

      <CountriesTable
        rows={rows}
        page={page}
        pageSize={pageSize}
        total={total}
        isLoading={isLoading || isFetching}
        filters={filters}
        setFilters={setFilters}
        onPageChange={setPage}
        onEdit={(row) => navigate(locationEditPath("countries", row.iso2))}
        onDelete={askDelete}
      />

      <ConfirmDialog
        open={confirmDelete.open}
        title="Delete country"
        message={
          confirmDelete.row
            ? `Delete country "${confirmDelete.row.name}"?`
            : "Delete this country?"
        }
        confirmText={deleting ? "Deleting…" : "Delete"}
        cancelText="Cancel"
        onCancel={cancelDelete}
        onConfirm={confirmDeleteRow}
      />
    </>
  );
};

export default CountriesTab;
